// Личные настройки /api/settings: часовой пояс и пол (фигура персонажа и карты мышц).

import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

import type { Sex } from '@/components/muscle-map/muscles'

import { api } from './client'

export type PersonalSettings = {
  timezone: string
  /** Пол из профиля; null — не задан. */
  sex: Sex | null
  /** С каким полом рисуется фигура: профиль → последний InBody → мужской. */
  body_sex: Sex
  body_sex_source: 'profile' | 'inbody' | 'default'
}

export type PersonalSettingsPatch = { timezone?: string; sex?: Sex | null }

export const settingsKey = ['settings'] as const

export function usePersonalSettings() {
  return useQuery({
    queryKey: settingsKey,
    queryFn: () => api.get<PersonalSettings>('/settings'),
    staleTime: 5 * 60_000,
  })
}

/** Пол фигуры; пока настройки не пришли — мужская. */
export function useBodySex(): Sex {
  const sex = usePersonalSettings().data?.body_sex
  return sex === 'female' ? 'female' : 'male'
}

export function useSavePersonalSettings() {
  const client = useQueryClient()
  return useMutation({
    mutationFn: (patch: PersonalSettingsPatch) => api.patch<PersonalSettings>('/settings', patch),
    onSuccess: (data) => {
      client.setQueryData(settingsKey, data)
      void client.invalidateQueries({ queryKey: ['character'] })
    },
  })
}
